import {initSwiperServices} from "./swiperServices";
import {initLenisSmoothScroll} from "./lenisSmoothScroll";
import {
    initContentNavigationHeaderSwitch,
    initContentNavigationIdObserver,
    initContentNavigationSnap
} from "./contentNavigationAdjustments";
import {initChildrenOnScrollAnimation} from "./animateChildrenOnScroll";
import {initPartnerTimelineAnimation} from "./animatePartnerTimeline";
import {initSwiperGallery} from "./swiperGallery";
import {initSwiperTestimonials} from "./swiperTestimonials";
import {initSwiperArticles} from "./swiperArticles";

document.addEventListener('DOMContentLoaded', () => {
    initSwiperServices();
    initSwiperGallery();
    initLenisSmoothScroll();
    initContentNavigationSnap();
    initContentNavigationHeaderSwitch();
    initContentNavigationIdObserver();
    initChildrenOnScrollAnimation();
    initPartnerTimelineAnimation();
    initSwiperTestimonials();
    initSwiperArticles();
});

